import { requestWithToken } from '../utilities/request';
const path = '/api/private/fields';

const defaultManagerUser = (fieldId, fieldTreeId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/${fieldId}/field_trees/${fieldTreeId}/field_tree_users/default_manager_user`
    ),
    params: param,
  });
};

const updateOrder = (fieldId, fieldTreeId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(
      `/${fieldId}/field_trees/${fieldTreeId}/field_tree_users/list`
    ),
    data: param,
  });
};

export const FieldTreeUserService = {
  defaultManagerUser,
  updateOrder,
};

export default FieldTreeUserService;



// WEBPACK FOOTER //
// ./src/services/FieldTreeUsers.js